import React from "react";
import "./section-aboutus.css";

//Components
import ButtonLink from "../../../components/ButtonLink/ButtonLink";
import ScrollAnimation from "react-animate-on-scroll";
//Assets
import ImageRunner from "../../../assets/images/Runner-AboutUs.png";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const SectionAboutUs = () => {
  const { userType } = useSelector((state) => state.userReducer);
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const navigation = useNavigate();
  const onClick = () => {
    if (isAuthenticated) {
      if (userType === "user") {
        navigation("/dashboard/history");
      } else {
        toast.error(
          "¡Debes iniciar sesión como Runner para acceder a esta sección!"
        );
      }
    } else {
      navigation("/auth");
    }
  };

  return (
    <>
      <div className="line-separator"></div>
      <section className="wraper-section-about">
        <article>
          <ScrollAnimation animateIn="backInLeft" animateOut="backOutLeft">
            <img src={ImageRunner} alt="Runner" className="" />
          </ScrollAnimation>
        </article>
        <aside className="text-info">
          <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut">
            <h2>
              Conoce un poco más de <span>Radaria</span>
            </h2>
            <p>
              En Radaria creemos que correr es más que un deporte, es una forma
              de conectar con nosotros mismos y con los demás. Nuestro propósito
              es crear una comunidad donde los corredores de todos los niveles
              puedan encontrar inspiración, apoyo y las herramientas necesarias
              para superar sus límites.
            </p>
            <div>
              <button
                onClick={onClick}
                className={`btn button-link ${`btn-primary active animate__animated animate__pulse animate__infinite infinite `}  m-2 ps-4 pe-4 `}
              >
                ¡Vamos!
              </button>
              <ButtonLink
                Text={"Comunidad"}
                isAvctive={false}
                link="/community"
              />
              <ButtonLink
                Text={"Servicios"}
                isAvctive={false}
                link="/services"
              />
            </div>
            <p>
              Somos una comunidad unida por nuestra pasión por correr, búsqueda
              de superación personal y deseo de conectar con otros que comparten
              la misma pasión.
            </p>
          </ScrollAnimation>
        </aside>
      </section>
      <div className="line-separator"></div>
    </>
  );
};

export default SectionAboutUs;
